import React, { ReactElement } from "react";
import styles from "./footer.module.scss";

export const FooterAppDownload = (props: Props): ReactElement => {
  return (
    <div className={styles.appDownload}>
      {props.title && <p className={styles.title}>{props.title}</p>}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        {props.items.map((item, i) => (
          <a href={item.link} key={i} target="_blank noreferrer">
            <img src={item.imageUrl} alt="Download the app" loading="lazy" />
          </a>
        ))}
      </div>
    </div>
  );
};

interface Props {
  title?: string;
  items: {
    imageUrl: string;
    link: string;
  }[];
}
